import type { FC, ReactElement, ReactNode } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type TooltipHelperProps = {
  id: string;
  title: ReactElement | string;
  child: ReactElement;
  disableTooltip?: boolean;
};
const TooltipHelper: FC<TooltipHelperProps> = ({ id, child, title, disableTooltip }) => (
  <OverlayTrigger
    overlay={
      <Tooltip id={id} placement="top">
        {title}
      </Tooltip>
    }
    show={disableTooltip ? false : undefined}
  >
    {child}
  </OverlayTrigger>
);

type TextWithTooltipProps = {
  id: string;
  tooltip: ReactNode;
  children: ReactNode;
  disableTooltip?: boolean;
  underlineStyle?: 'dashed' | 'dotted';
};
export const TextWithTooltip: FC<TextWithTooltipProps> = ({
  id,
  tooltip,
  children,
  disableTooltip,
  underlineStyle = 'dashed',
}) => (
  <OverlayTrigger
    overlay={
      <Tooltip id={id} placement="top">
        {tooltip}
      </Tooltip>
    }
    show={disableTooltip ? false : undefined}
  >
    <span
      style={
        !disableTooltip
          ? {
              textDecoration: `underline ${underlineStyle}`,
            }
          : undefined
      }
    >
      {children}
    </span>
  </OverlayTrigger>
);

export default TooltipHelper;
